import siteFlowPack from './site_flow.json';

export interface ConditionFamilyOption {
  id: string;
  label: string;
}

export interface SiteFlowConditionFamily {
  family_id: string;
  label: string;
  condition_types: ConditionFamilyOption[];
  tags: ConditionFamilyOption[];
  prompts_by_condition_type: Record<string, string[]>;
  operations_relevance_templates: Record<string, string>;
  suggested_corrective_actions: string[];
}

const pack = siteFlowPack as SiteFlowConditionFamily;

const DEFAULT_SITE_FLOW_PROMPTS = [
  'What workplace condition may be contributing to this recurring exposure?',
  'Is the intended safe route clear and practical?',
  'Does operations need to review layout, staging, or traffic flow?',
  'Is exposure concentrated at specific times or shift transitions?',
  'Would the same pattern occur regardless of which worker was present?',
];

export function loadSiteFlowConditionFamily(): SiteFlowConditionFamily {
  return pack;
}

export function getSiteFlowConditionTypeOptions(): ConditionFamilyOption[] {
  return pack.condition_types;
}

export function getSiteFlowTagOptions(): ConditionFamilyOption[] {
  return pack.tags;
}

export function resolveSiteFlowPromptsForConditionType(conditionTypeId: string): {
  prompts: string[];
  usedFallback: boolean;
} {
  const key = String(conditionTypeId || '').trim();
  if (!key) {
    return { prompts: [], usedFallback: false };
  }
  const specific = pack.prompts_by_condition_type[key];
  if (Array.isArray(specific) && specific.length > 0) {
    return { prompts: specific, usedFallback: false };
  }
  return { prompts: DEFAULT_SITE_FLOW_PROMPTS, usedFallback: true };
}

export function getSiteFlowPromptsForConditionType(conditionTypeId: string): string[] {
  return resolveSiteFlowPromptsForConditionType(conditionTypeId).prompts;
}

export function resolveSiteFlowConditionTypeLabel(conditionTypeId: string | null | undefined): string {
  const key = String(conditionTypeId || '').trim();
  if (!key) return '';
  const match = pack.condition_types.find((option) => option.id === key);
  return match?.label || key;
}

export function resolveSiteFlowTagLabels(tagIds: string[] | null | undefined): string[] {
  const ids = Array.isArray(tagIds) ? tagIds : [];
  const byId = new Map(pack.tags.map((tag) => [tag.id, tag.label]));
  return ids.map((id) => byId.get(String(id).trim()) || String(id).trim()).filter(Boolean);
}
